import { observable, action, makeObservable, runInAction } from 'mobx';
import message from '@/components/Toast';
import { RequestResult } from '@/api/requestType';
import {
    getTrainPlanConfigApi,
    getTrainTypeApi,
    getTrainTypeConfigApi,
    getTrainPlanCompleteInfoApi,
    getHeartSelectDataApi,
    deleteHeartSelectDataApi
} from '@/api/trainPlan';
class TrainingPlan {
    constructor() {
        makeObservable(this);
    }
    @observable business_id = '';
    @action
    setBusinessId = (v) => {
        this.business_id = v;
    };

    @observable trainPlanConfig = {};
    @action
    setTrainPlanConfig = (v) => {
        this.trainPlanConfig = Object.assign({}, this.trainPlanConfig, v);
    };
    // 获取培训计划配置
    getTrainPlanConfig = async (params) => {
        const res: RequestResult = await getTrainPlanConfigApi(params);
        if (res.code === '00000') {
            runInAction(() => {
                this.setTrainPlanConfig(res.data);
            });
        } else {
            return message.error(res.msg);
        }
    };

    @observable trainTypeList = [];
    // 获取培训类型
    getTrainTypeData = async (params) => {
        const res: RequestResult = await getTrainTypeApi(params);
        if (res.code === '00000') {
            runInAction(() => {
                this.trainTypeList = res.data || [];
            });
        } else {
            return message.error(res.msg);
        }
    };

    @observable currentTrainConfigInfo = {};
    @action
    setCurrentTrainConfigInfo = (v) => {
        this.currentTrainConfigInfo = Object.assign({}, this.currentTrainConfigInfo, v);
    };
    // 查询不通培训类型配置信息
    getConfigByType = async (params) => {
        const res: RequestResult = await getTrainTypeConfigApi(params);
        if (res.code === '00000') {
            runInAction(() => {
                this.setCurrentTrainConfigInfo(res.data);
            });
        } else {
            return message.error(res.msg);
        }
    };
    @observable completeStatusInfo = {};
    @action
    setCompleteStatusInfo = (v) => {
        this.completeStatusInfo = Object.assign({}, this.completeStatusInfo, v);
    };
    // 获取培训计划配置
    getCompleteStatusInfo = async (params) => {
        const res: RequestResult = await getTrainPlanCompleteInfoApi(params);
        if (res.code === '00000') {
            runInAction(() => {
                this.setCompleteStatusInfo(res.data);
            });
        } else {
            return message.error(res.msg);
        }
    };

    @observable heartChooseVisible = false;
    @action
    setHeartChooseVisible = (v) => {
        this.heartChooseVisible = v;
    };

    @observable heartListData = [];
    // 查询我的心选数据
    getHeartChooseList = async (params) => {
        const res: RequestResult = await getHeartSelectDataApi(params);
        if (res.code === '00000') {
            runInAction(() => {
                this.heartListData = res.data || [];
            });
        } else {
            return message.error(res.msg);
        }
    };

    // 删除心选
    deleteHeartChoose = async (id,index) => {
        const res: RequestResult = await deleteHeartSelectDataApi(id);
        if(res.code === '00000'){
            runInAction(() => {
                message.info('操作成功');
                this.heartListData.splice(index, 1);
            });
        } else {
            return message.error(res.msg);
        }
    };
}
export default new TrainingPlan();